var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGooglePlayStoreIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 24,
    viewBox: "0 0 23 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.3186 11.12L15.7555 7.71865L2.42114 0.292096C1.92632 0.016664 1.47695 -0.0471311 1.09473 0.0308406L12.3186 11.12Z",
    fill: "#434343"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.150822 0.819244C0.0557829 1.05822 0 1.33568 0 1.65871V22.3313C0 22.6544 0.053716 22.9288 0.146689 23.1647L11.4481 11.9803L0.150822 0.819244Z",
    fill: "#434343"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3226 12.8464L1.08838 23.966C1.47163 24.049 1.92514 23.9863 2.42513 23.7078L15.7833 16.265L12.3226 12.8464Z",
    fill: "#434343"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0211 10.6475L16.8745 8.33667L13.1948 11.9801L16.9003 15.6417L21.0211 13.3461C22.3547 12.6049 22.3547 11.3897 21.0211 10.6475Z",
    fill: "#434343"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGooglePlayStoreIcon);
export default __webpack_public_path__ + "static/media/google-play-store-icon.919a62f02bf1ad83533002b918329393.svg";
export { ForwardRef as ReactComponent };